import _ from 'lodash'

import { ADMIN_ROLES } from '@/constants'

export default {
  data() {
    return {
      ADMIN_ROLES,
      adminRoles: [
        {
          text: this.$t('common.roles.organization_admin'),
          id: ADMIN_ROLES.ORGANIZATION_ADMIN,
        },
        {
          text: this.$t('common.roles.site_admin'),
          id: ADMIN_ROLES.SITE_ADMIN,
        },
        { text: this.$t('common.none'), id: ADMIN_ROLES.NONE },
      ],
    }
  },

  methods: {
    getAdminRole(user) {
      if (!user) return { id: ADMIN_ROLES.NONE }

      if (user.isOrganizationAdmin) {
        return {
          text: this.$t('common.roles.organization_admin'),
          id: ADMIN_ROLES.ORGANIZATION_ADMIN,
        }
      }

      if (user.isSiteAdmin) {
        const hasMultipleSites =
          !_.isEmpty(user.managedSites) || !_.isEmpty(user.managedSiteGroups)

        return {
          text: hasMultipleSites
            ? this.$t('common.roles.multiple_site_admin')
            : this.$t('common.roles.site_admin'),
          id: ADMIN_ROLES.SITE_ADMIN,
        }
      }

      return { id: ADMIN_ROLES.NONE }
    },
  },
}
